module.exports = __webpack_public_path__ + "img/lznn.691627b0.png";